const UserOccupation = {
  STUDENT: 'student',
  TEACHER_UNIVERSITY: 'teacher_university',
  TEACHER_SCHOOL: 'teacher_school',
  TEACHER: 'teacher',
  PARENT: 'parent',
  SCHOOL_ADMIN: 'school_admin',
  DISTRICT_ADMIN: 'district_admin',
  OTHER: 'other',
  PERSONAL: 'personal',
  ADMINISTRATOR: 'administrator',
  INSTRUCTIONAL_TECH_COACH: 'instructional_tech_coach',
  DEPARTMENT_HEAD: 'department_head',
  CORPORATE: 'corporate',
  CORPORATE_TEACHER: 'corporate_teacher',
  CORPORATE_LEARNER: 'corporate_learner',
};

export default UserOccupation;
